// extracted by mini-css-extract-plugin
export default {"header":"header_header__UInOE","main-image":"header_main-image__QhGui"};